import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Overlay from 'components/atoms/Overlay/Overlay';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import ModalClose from 'components/assets/ModalClose.svg';
import classes from './PushNotificationsModal.module.scss';
import NotificationBell from 'components/assets/NotificationBell.svg';
import { useEnablePushNotifications } from 'hooks/useEnablePushNotifications';
import { PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY } from 'components/templates/AuthenticationProvider/Types';
import { usePushNotificationVisibility } from './usePushNotificationsVisibility';
import clsx from 'clsx';

export type PushNotificationModalProps = {
  onCancel: () => void;
  userName: string;
};

export default function PushNotificationsModal({ onCancel, userName }: PushNotificationModalProps) {
  const enablePushNotifications = useEnablePushNotifications();
  const { visibility, hideForDays } = usePushNotificationVisibility();

  const handleModalOnConfirm = async () => {
    enablePushNotifications();
    onCancel();
  };

  React.useEffect(() => {
    if (Date.now() > visibility.expDate) {
      window.localStorage.removeItem(PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY);
    }
  }, [visibility.expDate]);

  const handleOnCancel = () => {
    onCancel();
    hideForDays(7);
  };

  if (visibility.isVisible) {
    return (
      <Overlay>
        <Card className={classes.root}>
          <div className={classes.closeButton}>
            <Button buttonType="tertiary" onClick={handleOnCancel}>
              <ModalClose width={17} height={16} />
            </Button>
          </div>

          <div>
            <NotificationBell width={58} height={58} />
          </div>

          <Heading level={3} className={classes.heading}>
            Hey {userName ? { userName: userName } : 'there'},
          </Heading>

          <Txt className={classes.notificationText}>
            Get notified when there are new surveys available, so you never miss a chance to earn
          </Txt>

          <>
            <Button
              className={classes.actionButtons}
              buttonType="primary"
              buttonSize="large"
              onClick={handleModalOnConfirm}
            >
              <Txt>Please notify me</Txt>
            </Button>

            <Button
              className={clsx(classes.actionButtons, classes.cancelButton)}
              buttonType="tertiary"
              buttonSize="large"
              onClick={handleOnCancel}
            >
              <Txt>Not this time</Txt>
            </Button>
          </>
        </Card>
      </Overlay>
    );
  }
}
